import { render, staticRenderFns } from "./zhenTi.vue?vue&type=template&id=1620e049&scoped=true&"
import script from "./zhenTi.vue?vue&type=script&lang=js&"
export * from "./zhenTi.vue?vue&type=script&lang=js&"
import style0 from "./zhenTi.vue?vue&type=style&index=0&id=1620e049&prod&lang=css&"
import style1 from "./zhenTi.vue?vue&type=style&index=1&id=1620e049&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1620e049",
  null
  
)

export default component.exports